var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProcessingLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 60,
    fill: "#F4F4ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.572 170.762C223.143 170.762 223.143 58 138.572 58",
    stroke: "#0468FF",
    strokeWidth: 42.2857
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138.571 86.1904L54 198.952",
    stroke: "#1F34AB",
    strokeWidth: 42.2857
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54 114.381L82.1905 170.762",
    stroke: "#85AEFF",
    strokeWidth: 42.2857
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessingLight);
export default __webpack_public_path__ + "static/media/Processing-Light.4d7a1dea48da61079a59e296f0ac0212.svg";
export { ForwardRef as ReactComponent };